import api from "./api";

// Cada fetcher retorna { blob, filename } — filename extraído do header
// Content-Disposition retornado pelo backend (sempre enviado via File(...) no
// RelatoriosController). Com isso, o download usa o nome canônico gerado
// server-side, inclusive o slug do cliente em "por-cliente".

async function fetchRelatorio(url, params) {
  const res = await api.get(url, { responseType: "blob", params });
  return { blob: res.data, filename: parseFilename(res.headers?.["content-disposition"]) };
}

function parseFilename(cd) {
  if (!cd) return null;
  // Ex: attachment; filename="cliente-maria-silva.pdf"
  const m = cd.match(/filename="?([^";]+)"?/i);
  return m ? m[1].trim() : null;
}

// Period-aware (C2.4b): passa de/ate só quando AMBOS presentes (mesma regra do
// filtro da tela). Sem período → relatório completo (comportamento original).
export const fetchContasReceber = ({ de, ate } = {}) =>
  fetchRelatorio("/relatorios/contas-receber", de && ate ? { de, ate } : undefined);
export const fetchContasPagar = ({ de, ate } = {}) =>
  fetchRelatorio("/relatorios/contas-pagar", de && ate ? { de, ate } : undefined);

// PR2b — filtro de categoria agora é por ID (int). Backend aceita ambos
// (categoriaId tem precedência, `categoria` string fica como fallback até PR3).
export const fetchPorPeriodo = ({ de, ate, clienteId, categoriaId, categoria }) => {
  const params = { de, ate };
  if (clienteId) params.clienteId = clienteId;
  if (categoriaId) params.categoriaId = categoriaId;
  if (categoria) params.categoria = categoria;
  return fetchRelatorio("/relatorios/por-periodo", params);
};

export const fetchPorCliente = (clienteId) =>
  fetchRelatorio(`/relatorios/por-cliente/${clienteId}`);

export const fetchFluxoCaixa = () => fetchRelatorio("/relatorios/fluxo-caixa");

// PDF do Extrato — mesma lógica do endpoint JSON, renderizada em formato A4.
export const fetchExtrato = ({ de, ate }) =>
  fetchRelatorio("/relatorios/extrato", { de, ate });

// ─── Helpers de UI ───
// Padrão do PDF de roteiro: preview em nova aba, download via <a download>.
// Revoga URL após 60s — tempo suficiente pro browser renderizar o PDF.

export function openBlobInTab(newTab, blob) {
  const url = window.URL.createObjectURL(blob);
  newTab.location.href = url;
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "relatorio.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

// Quando o endpoint retorna erro (400/404/500) com responseType=blob, axios
// entrega o body como Blob — não como JSON. Essa função tenta extrair a
// mensagem de erro original (que o backend manda como { message: "..." }).
export async function extractBlobErrorMessage(err) {
  const data = err?.response?.data;
  if (!(data instanceof Blob)) return null;
  try {
    const text = await data.text();
    const parsed = JSON.parse(text);
    return parsed?.message ?? null;
  } catch {
    return null;
  }
}
